import * as React from 'react';
import { RenderElementProps } from 'slate-react';

export const hasOnlyEmptyTextNode = (element) => {
  if (element.children.length === 1) {
    const nodeText = element.children[0] as any;
    if (nodeText.text === '') {
      return true;
    }
  }

  return false;
};

export const ParagraphPlugin = {
  renderElement: (renderElementProps: RenderElementProps) => {
    const { element, children, attributes } = renderElementProps;

    if (element.type === 'p' || element.type === 'paragraph') {
      if (element.children.length === 0) {
        return <p {...attributes}>&nbsp;</p>;
      }
      if (hasOnlyEmptyTextNode(element)) {
        return <p {...attributes}>&nbsp;</p>;
      }
      return <p {...attributes}>{children}</p>;
    }
  },
};
